import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import IdentityAnchor from "@/pages/IdentityAnchor";
import CommandCenter from "@/pages/CommandCenter";
import CampaignHUD from "@/pages/CampaignHUD";
import LeadSentry from "@/pages/LeadSentry";
import Wallet from "@/pages/Wallet";
import ReferralBridge from "@/pages/ReferralBridge";
import BrandSignals from "@/pages/BrandSignals";
import APIVault from "@/pages/APIVault";
import Onboarding from "@/pages/Onboarding";
import client from "@/lib/api";

function ProtectedRoute({ children }) {
  const authed = typeof window !== "undefined" && localStorage.getItem("eigoo_anchor") === "verified";
  if (!authed) return <Navigate to="/anchor" replace />;
  return children;
}

function App() {
  useEffect(() => {
    client.post("/seed").catch(() => {});
  }, []);

  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/anchor" element={<IdentityAnchor />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<CommandCenter />} />
            <Route path="hud" element={<CampaignHUD />} />
            <Route path="sentry" element={<LeadSentry />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="bridge" element={<ReferralBridge />} />
            <Route path="signals" element={<BrandSignals />} />
            <Route path="vault" element={<APIVault />} />
            <Route path="onboard" element={<Onboarding />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #D4AF37",
            color: "#F5F5F5",
            borderRadius: 0,
            fontFamily: "Montserrat, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
